/** Backend stores employment scale as factor f in [0, 1]. UI shows percent. */

export function factorToPercent(factor: string | number): number {
  const n = Number(factor);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100 * 100) / 100;
}

export function formatEmploymentPercent(factor: string | number): string {
  const p = factorToPercent(factor);
  const s = Number.isInteger(p) ? String(p) : p.toFixed(2).replace(/\.?0+$/, '');
  return `${s}%`;
}

/** Converts UI percent to API factor string, or null if invalid. */
export function percentToFactorString(percent: string | number): string | null {
  const n = Number(String(percent).trim());
  if (!Number.isFinite(n) || n < 0 || n > 100) return null;
  const rounded = Math.round((n / 100) * 10000) / 10000;
  return String(rounded);
}

export function validateEmploymentPercentInput(percent: string): string | null {
  if (!percent.trim()) return 'Enter employment % (0–100).';
  if (percentToFactorString(percent) === null) return 'Employment % must be between 0 and 100.';
  return null;
}
